export default __webpack_public_path__ + "static/gnosis-df54c889324e296158f330068da7f81a.svg";